<script>
import ApiJustificationSummary from './ApiJustificationSummary.vue'

export default {
  components: {
    'justification-summary': ApiJustificationSummary,
  },
  props: {
    canShowRational: { type: Boolean, required: true },
    isLoading: { type: Boolean, default: false },
    selected: { type: Boolean, required: true },
    predictedDiagnosis: { type: Object, required: true },
    healthData: { type: Object, required: true },
    suggestionJustifications: { type: Object, default: null },
  },
  emits: ['make-selection'],
  data() {
    return {
      showRationals: false,
    }
  },
  computed: {
    // Distinguishes "justification hidden by settings" from "genuinely none" for the empty-state
    // wording below. The AI automation preview (getAutomationCandidateDiagnoses in
    // StayDisplayerPage.vue) doesn't ship raw hints, only the already-thresholded canShowRational —
    // fall back to that when hints are absent, rather than crashing on undefined.length.
    hasRational() {
      return this.predictedDiagnosis.hints ? this.predictedDiagnosis.hints.length > 0 : this.canShowRational
    },
    apiJustification() {
      return this.suggestionJustifications?.[`${this.predictedDiagnosis.type}:${this.predictedDiagnosis.diagnosis.reference}`] ?? null
    },
  },
  methods: {
    makeSelection() {
      this.$emit('make-selection', {
        labelType: this.predictedDiagnosis.type,
        labelReference: this.predictedDiagnosis.diagnosis.reference,
        savedSearchIds: [],
      })
    },
    handleHealthDataSelection(mainContent, scrollTarget = null) {
      this.$store.commit('setScrollTarget', scrollTarget)
      this.$store.commit('setMainContent', mainContent)
      if (!this.selected) {
        this.makeSelection()
      }
      this.showRationals = !this.showRationals
    },
    toggleRationals() {
      this.showRationals = !this.showRationals
      if (this.showRationals) {
        this.makeSelection()
      }
    },
    flagJustification(payload) {
      this.$store.dispatch('createFalseJustificationForSuggestion', payload)
    },
    unflagJustification({ justificationId, docType, docId }) {
      this.$store.dispatch('deleteFalseJustification', {
        justificationId,
        reportId: docType === 'report' ? docId : null,
        healthEntryId: docType === 'textualHealthEntry' ? docId : null,
      })
    },
  }
}
</script>

<template>
  <div
    :class="{ selected: showRationals }"
    @click="toggleRationals"
  >
    <v-dropdown
      :shown="showRationals"
      placement="left"
      class="popover-container"
      popover-class="justification-popover"
    >
      <slot />
      <template #popper>
        <justification-summary
          :is-loading="isLoading"
          :justification="canShowRational ? apiJustification : null"
          :health-data="healthData"
          :label-type="predictedDiagnosis.type"
          :label-reference="predictedDiagnosis.diagnosis.reference"
          :no-value-label="hasRational ? 'Justification non disponible en raison des paramètres' : 'Pas de justification'"
          @select-health-data="handleHealthDataSelection"
          @flag-justification="flagJustification"
          @unflag-justification="unflagJustification"
        />
      </template>
    </v-dropdown>
  </div>
</template>
